import React from "react";
import SamsonGidado from "../../assets/staff/SchoolofHealthInformationManagement/Samson_Gidado.jpg";
import AdedejiRonke from "../../assets/staff/SchoolofHealthInformationManagement/Adedeji_Ronke.jpg";
import OmotoshoStephen from "../../assets/staff/SchoolofHealthInformationManagement/Omotosho_Stephen.jpg";
import EletaMichael from "../../assets/staff/SchoolofHealthInformationManagement/Eleta_Michael.jpg";
import AbubakarBashir from "../../assets/staff/SchoolofHealthInformationManagement/Abubakar_Bashir.jpg";
import AkinyemiOlamide from "../../assets/staff/SchoolofHealthInformationManagement/Akinyemi_Olamide.jpg";
import RufaiDamilola from "../../assets/staff/SchoolofHealthInformationManagement/Rufai_Damilola.jpg";
import AkinwunmiMuyiwa from "../../assets/staff/Default/male.jpg";
import BankoleEmmanuel from "../../assets/staff/Default/male.jpg";
import FarindeRhoda from "../../assets/staff/MedicalandPsychiatrysocialwork/rhoda_farinde.jpeg";
import AjayiEsther from "../../assets/staff/Default/female.jpg";

const SchoolofHealthInformationManagementStaff = [
    {
        name: "Samson A. Gidado ",
        qualification: "PhD  HIM (in view/on thesis), MSc HIM(2023), BSc HIM(2018), MBA General Management (2000), PGD Management (1998), HND  Health Records Administration & Biostatistics (1996),Cert. in Leadership  ",
        designation: "Director and Head, SHIM",
        photo: SamsonGidado,
    },
    {
        name: "Adedeji O. Ronke",
        qualification: "MSc.Anatomy (2006), BSc.HIM (2022)BSc.Anatomy (2000),HND HIM (2005)",
        designation: "Deputy Director (Lecturer)",
        photo: AdedejiRonke,
    },
    {
        name: "Farinde O. Rhoda ",
        qualification: "MPH. Public Health (2013), PGD Education (2023),PGD Hospital Management (2009),BSc. Math & Statistics (2002),HND HIM (1999),MEd In view",
        designation: "Deputy Director (Lecturer)",
        photo: FarindeRhoda,
    },
    {
        name: "Omotosho S. Stephen",
        qualification: "BSc. HIM (2015),BSc. Computer Sci. (2009)",
        designation: "Health Information Management Officer I (Lecturer)",
        photo: OmotoshoStephen,
    },
    {
        name: "Bankole Emmanuel ",
        qualification: "MSc. HIM (2021),MEd.G&C (2006),BSc. HIM (2020),BA Ed Eng. (1999),NCE Business (1992)",
        designation: "Deputy Director (Lecturer)",
        photo: BankoleEmmanuel,
    },
    {
        name: "Eleta A. Michael",
        qualification: "BSc, Chemical Engineering 2007, PGD, Biomedical Engineering 2018 MSc, Biomedical Engineering, in view",
        designation: "Health Information Management Officer II (Lecturer) ",
        photo: EletaMichael,
    },
    {
        name: "Abubakar, Mohammed Bashir",
        qualification: "MSc.HIM,MSc. Computer Service,BSc. HIM",
        designation: "Health Information Management Officer II (Lecturer)",
        photo:  AbubakarBashir,
    },
    {
        name: "Ajayi Esther Abosede",
        qualification: "Technician 2015,BSc. HIM 2020",
        designation: "Health Information Management Officer II (Lecturer) ",
        photo: AjayiEsther,
    },
    {
        name: "Akinyemi Sarah Olamide",
        qualification: " HND HIM 2017,BSc.HIM 2020,MSc.2024",
        designation: "Health Information Management Officer II (Lecturer)",
        photo: AkinyemiOlamide,
    }, {
        name: "Rufai Damilola",
        qualification: "ND HIM (2013),BSc. Demography and Statistics (2022)",
        designation: "Locum Health Information Management Officer II (Lecturer)",
        photo: RufaiDamilola,
    }, {
        name: "Akinwunmi Muyiwa",
        qualification: "MSc. Management & International Business(2015),BSc. Accounting (2011)",
        designation: "Senior Technical Officer (Biomedical)",
        photo: AkinwunmiMuyiwa,
    }
];

export default SchoolofHealthInformationManagementStaff;